const ResponsiveTable = ({ columns, rows, onRowClick, mobileCard }) => (
  <>
    <div className="hidden overflow-x-auto sm:block">
      <table className="w-full text-left text-sm">
        <thead>
          <tr className="border-b border-zinc-200 dark:border-zinc-800 text-zinc-600 dark:text-zinc-500">
            {columns.map((col) => (
              <th key={col.key} className="px-4 py-3 font-medium">
                {col.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr
              key={row.id}
              onClick={() => onRowClick?.(row)}
              className={`border-b border-zinc-200/80 dark:border-zinc-800/80 ${onRowClick ? 'cursor-pointer hover:bg-zinc-200/50 dark:bg-zinc-800/50' : ''}`}
            >
              {columns.map((col) => (
                <td key={col.key} className="px-4 py-3 text-zinc-700 dark:text-zinc-300">
                  {col.render(row)}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>

    <div className="space-y-3 sm:hidden">
      {rows.map((row) => (
        <div
          key={row.id}
          role={onRowClick ? 'button' : undefined}
          tabIndex={onRowClick ? 0 : undefined}
          onClick={() => onRowClick?.(row)}
          onKeyDown={(e) => e.key === 'Enter' && onRowClick?.(row)}
          className={`rounded-xl border border-zinc-200 dark:border-zinc-800 bg-white dark:bg-zinc-900 p-4 ${onRowClick ? 'cursor-pointer' : ''}`}
        >
          {mobileCard
            ? mobileCard(row)
            : columns.map((col) => (
                <div key={col.key} className="flex justify-between gap-4 py-1 text-sm">
                  <span className="text-zinc-600 dark:text-zinc-500">{col.label}</span>
                  <span className="text-right text-zinc-800 dark:text-zinc-200">{col.render(row)}</span>
                </div>
              ))}
        </div>
      ))}
    </div>
  </>
);

export default ResponsiveTable;
